import React, { useContext, createContext, useMemo, useState } from 'react';

const DataProviderContext = createContext();

export const useDataProvider = () => {
  const context = useContext(DataProviderContext);
  return context;
};

export const DataProvider = ({ children }) => {
  const [practiceArea, setPracticeArea] = useState([]);
  const [venueOptions, setVenueOptions] = useState([]);
  const [tagList, setTagList] = useState(null);
  const [caseStageList, setCaseStageList] = useState([]);
  const [leadStages, setLeadStages] = useState([]);
  const [caseMatterList, setCaseMatterList] = useState([]);
  const [eventLocations, setEventLocations] = useState([]);
  const [typeList, setTypeList] = useState([]);

  const clearAllData = () => {
    setPracticeArea([]);
    setVenueOptions([]);
    setTagList(null);
    setCaseStageList([]);
    setLeadStages([]);
    setCaseMatterList([]);
    setEventLocations([]);
    setTypeList([]);
  };

  const values = useMemo(
    () => ({
      practiceArea,
      setPracticeArea,
      venueOptions,
      setVenueOptions,
      tagList,
      setTagList,
      caseStageList,
      setCaseStageList,
      leadStages,
      setLeadStages,
      caseMatterList,
      setCaseMatterList,
      eventLocations,
      setEventLocations,
      typeList,
      setTypeList,
      clearAllData,
    }),
    [practiceArea, venueOptions, tagList, caseStageList, leadStages, caseMatterList, eventLocations, typeList]
  );

  return <DataProviderContext.Provider value={values}>{children}</DataProviderContext.Provider>;
};
